import { Box, Grid, makeStyles, CircularProgress } from "@material-ui/core"
import NCModal from "../../shared/NCModal"
import NCButton from "../../shared/NCButton"
import NCInput from "../../shared/NCInput"
import { DriverProfileIcon, SearchIcon } from "../../libs/icons"
import NCText from "../../shared/NCText"
import { useEffect, useState } from "react"
import { useAssignDriver } from "../../services/mutations"
import { toast } from "react-toastify"
import { useQueryClient } from "react-query"
import { useGetDriverList } from "../../services/queries"

const useStyles = makeStyles({
  driver: {
    marginBottom: "10px",
    borderRadius: "35px",
    display: "inline-flex",
    position: "relative",
    cursor: "pointer",
    width: "100%",

    "&:hover": {
      backgroundColor: "#1EAAC4"
    }
  },
  driver_active: {
    background: "#1EAAC4"
  }
})
const AddChangeDriverModal = ({
  modalState = false,
  handleClose,
  tripId,
  selectedDriver,
  skipAvailability = false
}) => {
  const cls = useStyles()
  const [query, setQuery] = useState("")
  const [selectedDriverId, setSelectedDriverId] = useState(null)
  const queryClient = useQueryClient()

  // Reset the picker each time the modal opens so the previous selection
  // (or the currently assigned driver) is never carried over.
  useEffect(() => {
    if (modalState) {
      setSelectedDriverId(null)
      setQuery("")
    }
  }, [modalState])
  const assignDriver = useAssignDriver()
  const { data, isLoading } = useGetDriverList(
    undefined,
    1, // page
    100, // page_size — load all drivers so the picker isn't limited to page 1
    undefined,
    undefined,
    "available",
    tripId,
    skipAvailability,
    true, // skip_distance — show all drivers regardless of distance
    true, // skip_conflict — show all drivers regardless of conflicts
    { enabled: !!tripId }
  )
  const driverList = data?.data?.data?.results || []
  const handleDriverData = driver => {
    const id = driver?.user
    setSelectedDriverId(id)
  }

  const handleAssignDriver = () => {
    if (assignDriver.isLoading) return
    const data = {
      driver: selectedDriverId,
      id: tripId,
      skip_availability: skipAvailability,
      skip_distance: true, // allow assigning drivers beyond the 105-mile radius
      skip_conflict: true
    }
    assignDriver.mutate(data, {
      onSuccess: () => {
        toast.success("Driver Assigned successfully!")
        queryClient.invalidateQueries(["getRideDetails"])
        handleClose()
      }
    })
  }

  const requestModal = (
    <>
      <Grid container>
        <Grid item xs={12}>
          <NCText
            style={{
              marginLeft: "16px",
              color: "#2E3B36",
              fontSize: "14px",
              fontWeight: "550"
            }}
          >
            Best suitable Drivers list in recommended order for this Request
          </NCText>
        </Grid>
        <Grid item xs={12} style={{ margin: "10px" }}>
          <NCInput
            style={{ width: "100%" }}
            placeholder={"Search here"}
            value={query}
            onChange={e => {
              setQuery(e.target.value)
            }}
            startIcon={SearchIcon}
            className="rounded"
          />
        </Grid>
        <Box
          style={{
            overflow: "hidden",
            overflowY: "scroll",
            margin: "10px",
            maxHeight: "250px",
            width: "100%"
          }}
        >
          {isLoading ? (
            <Box style={{ textAlign: "center", padding: "20px" }}>
              <CircularProgress size={28} color="primary" />
            </Box>
          ) : driverList && driverList.length > 0 ? (
            driverList
              .filter(currentDriver => currentDriver?.user !== selectedDriver)
              .filter(currentDriver => {
                if (!query || query === "") {
                  return true
                }
                return (
                  currentDriver?.name &&
                  currentDriver.name
                    .toLowerCase()
                    .includes(query.toLowerCase())
                )
              })
              .map(currentDriver => {
                return (
                  <div
                    key={currentDriver.user}
                    id="driver"
                    className={
                      selectedDriverId === currentDriver.user
                        ? `${cls.driver_active} ${cls.driver}`
                        : cls.driver
                    }
                    onClick={() => {
                      handleDriverData(currentDriver)
                    }}
                  >
                    <label
                      htmlFor="driver"
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center"
                      }}
                    >
                      <Box paddingTop={"5px"}>
                        {currentDriver?.avatar ? (
                          <img
                            src={currentDriver?.avatar}
                            style={{
                              width: "30px",
                              height: "30px",
                              margin: "2px",
                              padding: "1px",
                              borderRadius: "50%"
                            }}
                          />
                        ) : (
                          <DriverProfileIcon
                            style={{
                              width: "30px",
                              height: "37px",
                              marginLeft: "3px",
                              marginRight: "3px"
                            }}
                          />
                        )}
                      </Box>
                      <NCText
                        style={{
                          fontWeight: "bold",
                          fontSize: "16px"
                        }}
                      >
                        {currentDriver?.name}
                      </NCText>
                    </label>
                  </div>
                )
              })
          ) : (
            <Box style={{ textAlign: "center", padding: "20px" }}>
              <NCText style={{ color: "#9CA3AF" }}>No drivers available</NCText>
            </Box>
          )}
        </Box>
      </Grid>
    </>
  )

  return (
    <NCModal
      open={modalState}
      title={selectedDriver ? "Change Driver" : "Add Driver"}
      text={requestModal}
      onClose={() => handleClose()}
      submitButton={
        <NCButton
          variant="contained"
          color="primary"
          disableElevation
          disabled={assignDriver.isLoading || !selectedDriverId}
          onClick={() => handleAssignDriver()}
          style={{ width: "auto", marginRight: "12px" }}
        >
          {assignDriver.isLoading ? "Assigning..." : (selectedDriver ? "Change Driver" : "Add Driver")}
        </NCButton>
      }
    />
  )
}
export default AddChangeDriverModal
